import Request from '@/jslib/dk-axios'

export const styleList = (data) => {
  return Request({
    url: 'Style',
    method: 'GET',
    params: data,
  })
}

export const addStyle = (data) => {
  return Request({
    url: 'Style',
    method: 'POST',
    data,
  })
}

export const editStyle = (data, uuid) => {
  return Request({
    url: `Style/${uuid}`,
    method: 'PUT',
    data,
  })
}

export const delStyle = (data) => {
  return Request({
    url: `Style/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const styleDetail = (data) => {
  return Request({
    url: `Style/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}
//  品牌管理
export const brandList = (data) => {
  return Request({
    url: 'Brand',
    method: 'GET',
    params: data,
  })
}

export const addBrand = (data) => {
  return Request({
    url: 'Brand',
    method: 'POST',
    data,
  })
}

export const editBrand = (data) => {
  return Request({
    url: `Brand/${data.uuid}`,
    method: 'PUT',
    data,
  })
}

export const delBrand = (data) => {
  return Request({
    url: `Brand/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const brandDetail = (data) => {
  return Request({
    url: `Brand/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/style.js